import { AddFavoriteItemRequest, ItemImageReportDTO } from '../api/api';
import WorkClient from '../api/workClient';

const reportImage = (body: ItemImageReportDTO) => {
  return WorkClient.reportItemImage(body);
};

const updateFavoriteItems = (body: AddFavoriteItemRequest) => {
  return WorkClient.addFavoriteItem(body);
};

const getFavoriteItemGroups = () => {
  return WorkClient.getFavoriteItemGroups();
};

const createFavoriteItemGroup = (groupName: string) => {
  return WorkClient.createFavoriteItemGroup(groupName);
};

const deleteFavoriteItem = (itemId: string) => {
  return WorkClient.deleteFavoriteItem(itemId);
};

const deleteFavoriteItemGroup = (groupId: number) => {
  return WorkClient.deleteFavoriteItemGroup(groupId);
};

const ItemService = {
  reportImage,
  updateFavoriteItems,
  getFavoriteItemGroups,
  createFavoriteItemGroup,
  deleteFavoriteItem,
  deleteFavoriteItemGroup
};

export default ItemService;
